import type { MenuRootProps } from '@base-ui/react';

import { Menu as BaseMenu } from '@base-ui/react';

type Props = MenuRootProps;

export const MenuRoot = ({ children, ...delegated }: Props) => {
  return (
    <BaseMenu.Root {...delegated} modal={delegated.modal ?? false}>
      {children}
    </BaseMenu.Root>
  );
};
